import React, { useState } from "react";
import { Modal } from "../modal/Modal";
import { useTranslation } from "react-i18next";
import { Eye } from "lucide-react";
import CachedImage from "./CachedImage";
export interface ImagePreviewGalleryProps {
  url?: string | null;
  children?: React.ReactNode;
  className?: string;
}

const ImagePreview: React.FC<ImagePreviewGalleryProps> = ({
  url,
  children,
  className,
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return !url ? (
    <div className="p-2">{children}</div>
  ) : (
    <>
      <button
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(true);
        }}
        type="button"
        className={`p-2 text-gray-500 hover:text-gray-600 dark:text-gray-400 dark:hover:text-gray-500 ${className}`}
      >
        {children || <Eye size={16} />}
      </button>
      <Modal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={t("form.preview")}
        closeIcon={true}
      >
        <div className="mb-4 min-h-[100px] md-w-[500px] md:min-h-[400px] min-w-[300px] md:min-w-[500px]">
          {url && (
            <div className="rounded-lg bg-gray-100 dark:bg-gray-700">
              <CachedImage
                src={url}
                className="rounded-lg w-full md:w-[500px]"
              />
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default ImagePreview;
